import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trainersData: [],
};

const trainersDataSlice = createSlice({
  name: "trainersData",
  initialState,
  reducers: {
    setTrainersData: (state, action) => {
      state.trainersData = action.payload;
    },
  },
});

export const { setTrainersData } = trainersDataSlice.actions;
export const selectTrainersData = (state) => state.trainersData.trainersData;

export default trainersDataSlice.reducer;
